import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from 'lib/src/hooks/usePrevious';
import useForm from '@components/form/hooks/useForm';

import { useHistory } from 'react-router-dom';
import { getTagRouteEndpoint } from '../utils';
import {
    getChallengeTagsIsPosting,
    getChallengeTagsPostError,
    getChallengeTagsPostSuccess,
} from '@selectors/challengeTags';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import { postCreateTag } from '@actions/challengeTags/postCreateTag';

export default function useCreateTag(type: tagTypes) {
    const dispatch = useDispatch();
    const history = useHistory();
    const endpoint = getTagRouteEndpoint(type);
    const closeModal = useCallback(() => {
        history.push(`/${endpoint}`);
    }, [history, endpoint]);

    const [formState, handleChange] = useForm<FormState>({
        name: '',
        isPublic: false,
        type,
    });

    const handleSubmit = useCallback(() => {
        dispatch(postCreateTag(formState));
    }, [dispatch, formState]);

    const isPosting = useSelector(getChallengeTagsIsPosting);
    const error = useSelector(getChallengeTagsPostError);
    const postSuccess = useSelector(getChallengeTagsPostSuccess);
    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            closeModal();
        }
    }, [postSuccess, prevPostSuccess, closeModal]);

    return {
        handleSubmit,
        formState,
        handleChange,
        closeModal,
        isPosting,
        error,
    };
}

interface FormState {
    name: string;
    isPublic: boolean;
    type: tagTypes;
}
